<template>
  <van-pull-refresh v-model="isLoading" @refresh="onRefresh" pulling-text="refresh data" loosing-text="reload data" loading-text="loading..." success-text="refresh success">
    <form action="/">
      <van-search v-model="searchvalue" placeholder="Please inser keyword" @search="onSearch" @cancel="onCancel" />
    </form>
    <van-dropdown-menu>
      <van-dropdown-item v-model="tempData.curtype" :options="typeOptions" @change="typeChange" />
      <van-dropdown-item v-model="tempData.curarea" :options="cityOptions" @change="cityChange" />
      <van-dropdown-item v-model="tempData.cursort" :options="SortbyOptions" @change="sortChange" />
    </van-dropdown-menu>
    <van-list v-model="loading" :loading-text="'Loading...'" :finished="finished" finished-text="End of content" @load="onLoad">
      <div class="store-container">
        <v-card v-for="(item, index) in itemList" :key="index" class="store-card">
          <div class="store-row" @click="openPage(item)">
            <div class="store-image">
              <img :src="item.logo" />
            </div>

            <div class="store-content">
              <div class="store-info">
                <div class="store-name">
                  <div>{{ item.title }}</div>
                  <van-rate v-model="item.level" :size="13" :count="5" allow-half void-icon="star" void-color="#eee" />
                </div>
                <div class="store-tags">
                  <div class="store-tag" v-for="(tagItem, tagIndex) in item.tags" :key="tagIndex">{{ tagItem }}</div>
                </div>
                <div class="store-address">
                  <div class="address">{{ item.address }}
                    <van-icon name="location-o" color="#1989fa" />
                  </div>
                  <div class="distance">{{ item.store_distance }}</div>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </van-list>
  </van-pull-refresh>
</template>
<script>
import { getMerchantList } from '@/api/api'

export default {
  props: {
    storeGroupId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      searchvalue: '',
      itemList: [],
      itemList2: [],
      itemsTotal: 0, //总记录数
      // -------------
      typeOptions: [],
      cityOptions: [],
      SortbyOptions: [],
      // -------------
      tempData: {
        areaid: 0,
        typeid: 0,
        sortid: 0,
        curarea: 0,
        cursort: 0,
        curtype: 0,
        isposition: 1,
        lat: 3.1270672491668563,
        lng: 101.64436662579688,
        pindex: 0,
        chainstore_id: 0
      }
    }
  },
  components: {
  },
  beforeMount() {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 30000
    }
    navigator.geolocation.getCurrentPosition(position => {
      this.itemList = [];
      this.itemList2 = [];
      this.loading = true;
      this.tempData.lat = position.coords.latitude
      this.tempData.lng = position.coords.longitude
      this.fetchData();
    }, (err) => {
      console.log(err);
      this.fetchData();
    }, options);
  },
  mounted() {
    console.log('mounted >>>', this.tempData);
  },
  created() {
    this.tempData.chainstore_id = this.storeGroupId
  },
  methods: {
    fetchData() {
      getMerchantList("/app/index.php?i=2&c=entry&m=weisrc_dish&do=storelist", this.tempData).then(res => {
        const { itemsTotal, area, curarea, cursort, curtype, isposition, lat, lng, pindex, restlist, shoptype, shopsort } = res.data
        this.itemsTotal = itemsTotal || 0
        restlist && restlist.forEach(element => {
          element.level = parseInt(element.level)
          this.itemList.push(element)
        });
        this.itemList2 = this.itemList
        this.cityOptions = area
        this.typeOptions = shoptype
        this.SortbyOptions = shopsort

        this.loading = false
        if (this.itemList.length >= this.itemsTotal) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      }).catch((error) => {
        console.log('====>error', error)
      })
    },
    onSearch(val) {
      // this.$toast(val)
      const keyword = val.toLowerCase()
      if (keyword) {
        this.itemList = this.itemList2.filter(agentlist => {
          return Object.keys(agentlist).some(key => {
            return String(agentlist[key]).toLowerCase().indexOf(keyword) > -1
          })
        })
      } else {
        this.itemList = this.itemList2
      }
    },
    onCancel() {
      this.$toast('Cancel Button')
    },
    onLoad() {
      if (this.isLoading) {
        this.itemList = [];
        this.isLoading = false;
      }
      this.tempData.pindex++

      if(this.tempData.pindex > 1 && !this.finished) {
        this.fetchData();
      }
    },
    onRefresh() {
      this.itemList = [];
      this.itemList2 = [];
      this.loading = true;
      this.tempData.areaid = 0
      this.tempData.typeid = 0
      this.tempData.sortid = 0
      this.tempData.curarea = 0
      this.tempData.cursort = 0
      this.tempData.curtype = 0
      this.tempData.isposition = 1
      this.tempData.pindex = 1
      this.isLoading = true
      this.searchvalue = ''
      this.fetchData()
      setTimeout(() => {
        this.$toast('Refresh Success');
        this.isLoading = false;
      }, 1000);
    },
    typeChange(val) {
      this.itemList = [];
      this.itemList2 = [];
      this.loading = true;
      this.tempData.typeid = parseInt(val)
      this.fetchData()
    },
    cityChange(val) {
      this.itemList = [];
      this.itemList2 = [];
      this.loading = true;
      this.tempData.areaid = parseInt(val)
      this.fetchData()
    },
    sortChange(val) {
      this.itemList = [];
      this.itemList2 = [];
      this.loading = true;
      this.tempData.sortid = parseInt(val)
      this.fetchData()
    },
    openPage(item) {
      window.location.href = item.store_url
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.store-container {
  .store-card {
    .store-row {
      width: 100%;
      padding: 10px;
      margin-top: 16px;
      margin-bottom: 16px;
      display: flex;
      align-items: center;

      .store-image {
        img {
          width: 100px;
          height: 100px;
          object-fit: fill;
          border-radius: 10px;
        }
      }

      .store-content {
        flex: auto;
        text-align: left;
        padding-left: 16px;
        padding-right: 24px;

        .store-name {
          font-weight: bolder;
          padding-bottom: 10px;
        }

        .store-tags {
          display: flex; 
          flex-direction: row;
          flex-wrap: wrap;

          .store-tag {
            font-size: 9px;
            background: #03a9f4;
            border-radius: 10px;
            padding: 3px 5px;
            margin: 0 5px 3px 0;
            color: white;
            white-space: nowrap;
          }
        }

        .store-address {
          display: flex; 
          flex-direction: row; 
          color: rgba(0, 0, 0, 0.4);

          .address {
            text-transform: capitalize;
            font-style: italic;
            display: flex;
            flex: auto;
            font-size: 13px;

            i {
              padding-left: 6px;
            }
          }

          .distance {
            color: red;
            margin: 0 0 0 10px;
          }
        }
      }
    }
  }
}
</style>
